/* import __COLOCATED_TEMPLATE__ from './query-type.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { CxBenchmarkGroup } from './types';

interface QueryTypeRow {
  label: string;
  yourPercent: number;
  peerPercent: number;
}

interface Signature {
  Args: {
    benchmarkGroup: CxBenchmarkGroup | undefined;
  };
}

export default class QueryType extends Component<Signature> {
  @service declare intl: IntlService;

  // TODO: Compute from real benchmark reasons data
  get rows(): QueryTypeRow[] {
    return [
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.query-type.label-informational',
        ),
        yourPercent: 65.4,
        peerPercent: 33.3,
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.query-type.label-personalized',
        ),
        yourPercent: 10.4,
        peerPercent: 11.6,
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::CxBenchmarkPanel::QueryType': typeof QueryType;
    'reporting/bespoke/fin-performance/cx-benchmark-panel/query-type': typeof QueryType;
  }
}
